"use strict";

var Reflux = require("reflux");
var agendorAPI = require("app/util/api/agendor-api");

var TeamSelectFilterActions = Reflux.createActions({
    "loadTeams": {children: ["completed","failed"]}
});

TeamSelectFilterActions.loadTeams.listen(function(){
  agendorAPI.get("/teams", null, function(teams){
    this.completed(teams);
  }.bind(this));
});

module.exports = TeamSelectFilterActions;



// WEBPACK FOOTER //
// ./app/shared/actions/team-select-filter-actions.js